import { canShowFreeShippingThreshold } from "~/hooks/format-delivery-price.logic";

export interface FreeDeliveryProgressInput {
	deliveryCost: number | null | undefined;
	freeFrom: number | null | undefined;
	merchandiseTotalCents: number;
}

export interface FreeDeliveryProgress {
	isVisible: boolean;
	remainingCents: number;
	fillPercent: number;
	isUnlocked: boolean;
}

const HIDDEN: FreeDeliveryProgress = {
	isVisible: false,
	remainingCents: 0,
	fillPercent: 0,
	isUnlocked: false,
};

/**
 * Computes free-delivery progress for the currently selected delivery method.
 * Visible when `canShowFreeShippingThreshold` is true. Fill grows toward 100%
 * as merchandise total approaches freeFrom (progress toward free).
 */
export function getFreeDeliveryProgress({
	deliveryCost,
	freeFrom,
	merchandiseTotalCents,
}: FreeDeliveryProgressInput): FreeDeliveryProgress {
	if (!canShowFreeShippingThreshold(deliveryCost, freeFrom)) {
		return HIDDEN;
	}
	if (freeFrom === 0) {
		return {
			isVisible: true,
			remainingCents: 0,
			fillPercent: 100,
			isUnlocked: true,
		};
	}
	const remainingCents = Math.max(0, freeFrom - merchandiseTotalCents);
	const isUnlocked = merchandiseTotalCents >= freeFrom;
	const fillPercent = Math.min(
		100,
		Math.max(0, (merchandiseTotalCents / freeFrom) * 100),
	);
	return {
		isVisible: true,
		remainingCents,
		fillPercent,
		isUnlocked,
	};
}
